import ButtonBar from '../../Elements/ButtonBar'
import React, {useContext, useState } from 'react'
import ProductCategoryManager from '../../Elements/ProductCategoryManager'
import ProductModal from '../ProductsComponents/ProductModal'
import { UserContext } from '../../../context/UserContext'


const Genetics = () => {
  const [token] = useContext(UserContext);
  const[activeModal, setActiveModal] = useState(false);
  const [, setErrorMessage] = useState("");

  const handleModal = () => {
    setActiveModal(!activeModal);
  };

  const menu_bar = [
    {
      title: 'Genetica',
      buttons: [
        {
          label: 'Crear Genetica',
          color: 'green',
          onClick: () => {
            setActiveModal(true)
          },
        },
        // {
        //   label: 'Borrar Genetica',
        //   color: 'red',
        // },
        // {
        //   label: 'Actualizar Genetica',
        //   color: 'blue',
 
        // },
      ],
    },
  ];
  return (
    <>
      <div className="flex flex-col gap-4">
        {menu_bar.map((menuItem, index) => (
          <ButtonBar
            key={index}
            title={menuItem.title}
            buttons={menuItem.buttons}
          />
        ))}
      </div>
      <div className="bg-white p-4 rounded-lg shadow border border-gray-200 flex-auto">
      <ProductCategoryManager
        defaultCategory = {8}
      />
      </div>
      <ProductModal 
        active={activeModal}
        handleModal={handleModal}
        token={token}
        setErrorMessage={setErrorMessage}
    />

    </>
  );
}

export default Genetics;
